import React, { createContext, useState, useReducer } from 'react';

const REDUCER_ACTION_INITIALIZE = 'Initialize';
const REDUCER_ACTION_FILTER = 'Filter';
const REDUCER_ACTION_CHECK = 'Check';
const REDUCER_ACTION_CHECK_ALL = 'CheckAll';
const REDUCER_ACTION_UPDATE_STATUS = 'UpdateStatus';
const REDUCER_ACTION_UPDATE_STATUS_BATCH = 'UpdateStatusBatch';
const REDUCER_ACTION_UPDATE_AMOUNT = 'UpdateAmount';
const SecurityContext = createContext({});
const SecurityDispatchContext = createContext({});

/*
  SecurityProvider - provides complex state handling for the securities module
  that includes state for security details, invited clients, and orders
 */
const SecurityProvider = ({children}) => {
  // Security Information State
  const [securityState, setSecurityState] = useState({});
  // Invites List of Security State
  const [invitesState, setInvitesState] = useState([]);
  // Orders List of Security State
  const [ordersState, ordersDispatch] = useReducer(ordersReducer, {}, ()=>{})

  return (
    <SecurityContext.Provider value={{ securityState, invitesState, ordersState }}>
      <SecurityDispatchContext.Provider value={{ setSecurityState, setInvitesState, ordersDispatch}}>
        {children}
      </SecurityDispatchContext.Provider>
    </SecurityContext.Provider>
  )
}

/*
  Reducer for the orders state to handle complex handling of filtered state
  versus unfiltered state
 */
const ordersReducer = (state, action) => {
  const { type, previous, data } = action
  switch(type) {
    case REDUCER_ACTION_INITIALIZE:
      return {
        ...previous,
        default: data,
        filtered: data
      }
    case REDUCER_ACTION_FILTER:
      const filteredData = previous.default.filter( order =>
        order[data.filterBy].toLowerCase().includes(data.filter.toLowerCase()) &&
        (data.filterByStatus === '' && order.orderStatus !== '' ||
          data.filterByStatus !== '' && order.orderStatus === data.filterByStatus)
      );
      return {
        ...previous,
        filtered: filteredData
      }
    case REDUCER_ACTION_CHECK:
      const checkedDefaultData = previous.default.map(order => {
        if (order.orderId === data) {
          return {
            ...order,
            checked: !order.checked
          }
        }
        return order
      });
      const checkedFilteredData = previous.filtered.map(order => {
        if (order.orderId === data) {
          return {
            ...order,
            checked: !order.checked
          }
        }
        return order
      });
      return {
        ...previous,
        default: checkedDefaultData,
        filtered: checkedFilteredData
      }
    case REDUCER_ACTION_CHECK_ALL:
      const checkedAllDefaultData = previous.default.map(order => {
        return {
          ...order,
          checked: data
        }
      });
      const checkedAllFilteredData = previous.filtered.map(order => {
        return {
          ...order,
          checked: data
        }
      });
      return {
        ...previous,
        default: checkedAllDefaultData,
        filtered: checkedAllFilteredData
      }
    case REDUCER_ACTION_UPDATE_STATUS:
      const updatedStatusDefaultData = previous.default.map(order => {
        if (order.orderId === data.id) {
          return {
            ...order,
            orderStatus: data.value
          }
        }
        return order
      });
      const updatedStatusFilteredData = previous.filtered.map(order => {
        if (order.orderId === data.id) {
          return {
            ...order,
            orderStatus: data.value
          }
        }
        return order
      });
      return {
        ...previous,
        default: updatedStatusDefaultData,
        filtered: updatedStatusFilteredData
      }
    case REDUCER_ACTION_UPDATE_AMOUNT:
      const updatedAmountDefaultData = previous.default.map(order => {
        if (order.orderId === data.id) {
          return {
            ...order,
            scaledAmount: data.value
          }
        }
        return order
      });
      const updatedAmountFilteredData = previous.filtered.map(order => {
        if (order.orderId === data.id) {
          return {
            ...order,
            scaledAmount: data.value
          }
        }
        return order
      });
      return {
        ...previous,
        default: updatedAmountDefaultData,
        filtered: updatedAmountFilteredData
      }
    case REDUCER_ACTION_UPDATE_STATUS_BATCH:
      const updatedStatusBatchDefaultData = previous.default.map(order => {
        if (order.checked && order.orderStatus === '0') {
          return {
            ...order,
            orderStatus: data
          }
        }
        return order
      });
      const updatedStatusBatchFilteredData = previous.filtered.map(order => {
        if (order.checked && order.orderStatus === '0') {
          return {
            ...order,
            orderStatus: data
          }
        }
        return order
      });
      return {
        ...previous,
        default: updatedStatusBatchDefaultData,
        filtered: updatedStatusBatchFilteredData
      }
    default:
      throw new Error('Undefined Action.');
  }
}

export {
  SecurityProvider,
  SecurityContext,
  SecurityDispatchContext,
  REDUCER_ACTION_INITIALIZE,
  REDUCER_ACTION_FILTER,
  REDUCER_ACTION_CHECK,
  REDUCER_ACTION_CHECK_ALL,
  REDUCER_ACTION_UPDATE_STATUS,
  REDUCER_ACTION_UPDATE_AMOUNT,
  REDUCER_ACTION_UPDATE_STATUS_BATCH
}
